import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { adminAPI } from '../services/api';

let cachedMe = null;

export function useAdminPermissions() {
  const { isAdmin, isAuthenticated } = useAuth();
  const [me, setMe] = useState(cachedMe);
  const [loading, setLoading] = useState(isAdmin && !cachedMe);

  const load = useCallback(async () => {
    if (!isAuthenticated || !isAdmin) {
      setMe(null);
      cachedMe = null;
      setLoading(false);
      return null;
    }
    setLoading(true);
    try {
      const { data } = await adminAPI.getMe();
      cachedMe = data;
      setMe(data);
      return data;
    } catch {
      setMe(null);
      cachedMe = null;
      return null;
    } finally {
      setLoading(false);
    }
  }, [isAdmin, isAuthenticated]);

  useEffect(() => {
    load();
  }, [load]);

  const can = useCallback(
    (permission) => {
      if (!permission) return true;
      const perms = me?.permissions || [];
      if (perms.includes(permission)) return true;
      if (permission.endsWith(':read')) {
        const write = permission.replace(':read', ':write');
        if (perms.includes(write)) return true;
      }
      if (permission.endsWith(':read')) {
        const manage = permission.replace(':read', ':manage');
        if (perms.includes(manage)) return true;
      }
      return false;
    },
    [me]
  );

  return {
    me,
    loading,
    reload: load,
    can,
    adminGroup: me?.admin_group,
    adminGroupLabel: me?.admin_group_label,
    permissions: me?.permissions || [],
  };
}

export function clearAdminPermissionsCache() {
  cachedMe = null;
}
